import { render, staticRenderFns } from "./Lgx184757324802424832.vue?vue&type=template&id=0eda236d&"
import script from "./Lgx184757324802424832.vue?vue&type=script&lang=js&"
export * from "./Lgx184757324802424832.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports